// extracted by mini-css-extract-plugin
export default {"titleRow":"FunctionRegenIndicator_titleRow__ZDzpD","indicator":"FunctionRegenIndicator_indicator__ITDQL"};